import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ListingHeaderConfig } from '../interfaces/listing.interface';

@Component({
  selector: 'app-listing-header',
  templateUrl: './listing-header.component.html',
  styleUrls: ['./listing-header.component.scss']
})
export class ListingHeaderComponent {
  @Input() config!: ListingHeaderConfig;
  @Input() pageSize: number = 25;
  @Input() pageSizeOptions: number[] = [10, 25, 50, 100];
  @Input() isLoading: boolean = false;
  
  @Output() pageSizeChange = new EventEmitter<number>();
  @Output() backButtonClick = new EventEmitter<void>();

  onPageSizeChange(size: number): void {
    this.pageSizeChange.emit(size);
  }

  onBackClick(): void {
    if (this.config.backButtonRoute && typeof this.config.backButtonRoute === 'function') {
      this.config.backButtonRoute();
    } else {
      this.backButtonClick.emit();
    }
  }
}
